const initialState = {
    data: {
        size: 0,
        totalElements: 0,
        totalPages: 0,
        currentPage: 0,
        schedule: []
    },
    lote: {},
    contador: {},
    isLoading: true,
    isLoadingForecast: false,
    planning: false,
    hasErrored: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case '[SCHEDULE] HAS_ERRORED':
            return {...state, isLoading: false, data: initialState.data, hasErrored: true};
        case '[SCHEDULE] IS_LOADING':
            return {...state, hasErrored: false, data: initialState.data, isLoading: true};
        case '[SCHEDULE] FETCH_SUCCESS':
            return {...state, hasErrored: false, isLoading: false, planning: false, isLoadingForecast: false,data: action.data};
        case '[SCHEDULE] FETCH_SUCCESS_PERIOD':
            return {...state, hasErrored: false, isLoading: false, planning: false,isLoadingForecast: false,data_rf: action.data};
        case '[SCHEDULE] FETCH_SUCCESS_LOTE':
            return {...state, hasErrored: false, isLoading: false, lote: action.lote};
        case '[SCHEDULE] FETCH_SUCCESS_FORECAST':
            return {...state, hasErrored: false, isLoading: false, isLoadingForecast: false, planning: true};
        case '[SCHEDULE] IS_LOADING_FORECAST':
            return {...state, hasErrored: false, data: initialState.data, isLoadingForecast: true,isLoading: false};
        case '[SCHEDULE] FETCH_SUCCESS_CONTADOR':
            return {...state, hasErrored: false, isLoading: false, contador: action.data};
        case '[SCHEDULE] COUNT_FAILS':
            return {...state, countFails: action.countFails};
        default:
            return state;
    }
};
